import { render, staticRenderFns } from "./EditProductionModal.vue?vue&type=template&id=5fc58868&scoped=true&"
import script from "./EditProductionModal.vue?vue&type=script&lang=js&"
export * from "./EditProductionModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProductionModal.vue?vue&type=style&index=0&id=5fc58868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc58868",
  null
  
)

export default component.exports